import AppListing from '../app-components/Listing/AppListing';

Vue.component('app-prices-factory-listing', {
    mixins: [AppListing]
});